module.exports = __webpack_public_path__ + "img/funds-dollar.cf487b84.png";